import { PromoTypeEnum } from 'app/models';

export class PromoTypeModel {
    public static PromoTypeList: Array<any> = [
        { id: PromoTypeEnum.FreeDelivery, name: 'Free Delivery' },
        { id: PromoTypeEnum.Referral, name: 'Referral' },
        { id: PromoTypeEnum.Discount, name: 'Discount' },
        { id: PromoTypeEnum.PercentageDiscount, name: 'Percentage Discount' },
        { id: PromoTypeEnum.FixedAmountDiscount, name: 'Fixed Amount Discount' },
        { id: PromoTypeEnum.DeliveryFeeDiscount, name: 'Delivery Fee Discount' },
        { id: PromoTypeEnum.FreeItemPromo, name: 'Free Item Promo' },
        { id: PromoTypeEnum.Cebuana24K, name: 'Cebuana 24K' }
    ];

    public static PromoTypeShortList: Array<any> = [
        { id: PromoTypeEnum.Discount, name: 'Discount' },
        { id: PromoTypeEnum.Cebuana24K, name: 'Cebuana 24K' }
    ];
}
